import { render, staticRenderFns } from "./SettingsConfig.vue?vue&type=template&id=32d43ff6&"
import script from "./SettingsConfig.vue?vue&type=script&lang=js&"
export * from "./SettingsConfig.vue?vue&type=script&lang=js&"
import style0 from "./SettingsConfig.vue?vue&type=style&index=0&id=32d43ff6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports